var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.890869 20.3084C0.890869 9.19701 9.89843 0.189453 21.0098 0.189453C32.1212 0.189453 41.1288 9.19701 41.1288 20.3084C41.1288 31.4198 32.1212 40.4274 21.0098 40.4274C9.89843 40.4274 0.890869 31.4198 0.890869 20.3084Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1384 26.4373H14.8788C14.5031 26.4373 14.1975 26.1317 14.1975 25.7561V16.2216C14.1975 15.8459 14.5031 15.5403 14.8788 15.5403H17.6028L18.9653 14.1777H23.0519L24.4144 15.5403H27.1384C27.5141 15.5403 27.8197 15.8459 27.8197 16.2216V25.7561C27.8197 26.1317 27.5141 26.4373 27.1384 26.4373ZM21.0092 16.9017C18.7552 16.9017 16.9215 18.7354 16.9215 20.9894C16.9215 23.2427 18.7552 25.0759 21.0092 25.0759C23.2625 25.0759 25.0957 23.2427 25.0957 20.9894C25.0957 18.7366 23.2625 16.9028 21.0092 16.9017ZM21.0092 23.7134C20.0388 23.7134 19.1347 23.1913 18.6496 22.3508C18.1647 21.5107 18.1647 20.4669 18.6496 19.6268C19.1347 18.7864 20.0388 18.2643 21.0092 18.2643C21.9788 18.2643 22.8825 18.7864 23.3676 19.6268C23.8525 20.4669 23.8525 21.5107 23.3676 22.3508C22.8825 23.1913 21.9788 23.7134 21.0092 23.7134Z",
    fill: "#1E1A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.eb8fb1b0f93079b1fb865114a7d0397d.svg";
export { ForwardRef as ReactComponent };